var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSave = function SvgSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "save_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#save_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 19V5q0-.824.587-1.412A1.93 1.93 0 0 1 5 3h11.175a1.98 1.98 0 0 1 1.4.575l2.85 2.85q.275.275.425.638.15.361.15.762V19q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21zM19 7.85 16.15 5H5v14h14zM12 18q1.25 0 2.125-.875A2.9 2.9 0 0 0 15 15q0-1.25-.875-2.125A2.9 2.9 0 0 0 12 12q-1.25 0-2.125.875A2.9 2.9 0 0 0 9 15q0 1.25.875 2.125A2.9 2.9 0 0 0 12 18m-5-8h7q.424 0 .713-.287A.97.97 0 0 0 15 9V7a.97.97 0 0 0-.287-.713A.97.97 0 0 0 14 6H7a.97.97 0 0 0-.713.287A.97.97 0 0 0 6 7v2q0 .424.287.713Q6.576 10 7 10"
  }))));
};
export default SvgSave;